import React from 'react'

import { Link } from 'react-router-dom';
import { generateSlug } from '../utils/slugUtils';

const BlogGridMain = (props) => {
    const { blogID, blogImage, blogTitle, blogCategory, blogPublishedDate } = props;
    return (
        <>
            <div className="blog-header">
                <Link className="thumbnail" to={`/blog/${blogID}`}>
                    <img
                        src={blogImage}
                        alt="Business_Blog"
                    />
                </Link>
                {/* <div className="blog-info">
                    <div className="user">
                        <i className="fal fa-user-circle" />
                        <span></span>
                    </div>
                    {/* <div className="user">
                        <i className="fal fa-tags" />
                        <span>{blogCategory ? blogCategory : "Blog"}</span>
                    </div> 
                </div> */}
                <div className="date">
                            <h6 className="title">{blogPublishedDate ? new Date(blogPublishedDate).getDate() : '15'}</h6>
                            <span>{blogPublishedDate ? new Date(blogPublishedDate).toLocaleString('default', { month: 'short' }) : 'Jan'}</span>
                </div>
            </div>
            <div className="blog-body">
                <Link to={`/blog/${generateSlug(blogTitle)}`}>
                    <h5 className="title">
                        {blogTitle ? blogTitle : 'How to growing your business'}
                    </h5>
                </Link>
            </div>
        </>

    )
}

export default BlogGridMain